import { inject } from "@angular/core";
import { GetRowIdParams, GridOptions, RowClickedEvent } from "ag-grid-enterprise";
import { ViewsService } from "../../../../services/views/views.service";
import { View } from "@bitwarden/web-vault/app/models/enum/view.enum";
import { AccountView } from "@bitwarden/web-vault/app/models/view/account/account.view";
import { AccountRowRendererComponent } from "@bitwarden/web-vault/app/components/tables/renderers/cell/account-row-renderer/account-row-renderer.component";
import { AccountViewTableSubscription, TableSource } from "./account-view-table.subscription";
import { FilterControlType } from "@bitwarden/web-vault/app/services/store/calculation-base/controls/filter.control";

type AccountViewTableUIData = { icon: string };
type AccountViewTableDataSource = TableSource & AccountViewTableUIData;

export class AccountViewTable extends AccountViewTableSubscription {
  private viewsService: ViewsService;
  options: GridOptions<AccountViewTableDataSource>;

  constructor() {
    super();
    this.viewsService = inject(ViewsService);
    this.options = {
      suppressCellFocus: true,
      suppressContextMenu: true,
      columnDefs: [
        {
          cellRenderer: AccountRowRendererComponent,
          flex: 1,
          suppressSizeToFit: false,
          cellStyle: { padding: "0" },
          autoHeight: true, // This makes the row height fit the content
        },
      ],
      onGridReady: (params) => {
        params.api.sizeColumnsToFit();
        params.api.applyColumnState({
          state: [{ colId: "balance", sort: "desc" }],
        });
      },
      onRowClicked: (params) => this.onAccountClick(params),
      onGridSizeChanged: (params) => {
        params.api.sizeColumnsToFit();
      },
      getRowId: (params: GetRowIdParams) => String(params.data.id),
    };
  }

  async onAccountClick(event: RowClickedEvent) {
    const accountData = event.data as AccountView;
    this.filterOnAccount(accountData.id);
    this.viewsService.view = View.PAST;
  }

  private filterOnAccount(accountId: string) {
    const newFilter: FilterControlType = {
      ...this.calculationPastStoreService.filters.options(),
      accounts: [accountId],
    };

    this.calculationPastStoreService.filters.updateSelection(newFilter);
  }
}
